import {request, serviceUrl} from "@/utils/request";

// 获取已部署的流程列表
export function actList() {
  return request({
    url: serviceUrl.activitiService + '/act/repo/procdef/actList'
  })
}

// 根据id删除关联信息
export function deleteProcessByPid(ids) {
  return request({
    method: 'post',
    url: serviceUrl.activitiService + '/act/repo/procdef/delete',
    data: ids
  })
}

// 部署流程
export function publishProcess(data) {
  return request({
    url: serviceUrl.activitiService + '/act/repo/procdef/add',
    method: 'post',
    data: data
  })
}
// /act/repo/procdef/getFinishedInstance
// 查询Id获取已完成的流程实例
export function getFinishedInstance(data) {
  return request({
    url: serviceUrl.activitiService + '/act/repo/procdef/getFinishedInstance',
    params: data
  })
}

// /act/repo/procdef/getFinishedInstance
// 查询Id获取已完成的流程实例
export function getPage(data) {
  return request({
    url: serviceUrl.activitiService + '/act/repo/procdef/getPage',
    params: data
  })
}


export function getTaskInfo(id) {
  return request({
    method: 'post',
    url: serviceUrl.activitiService + '/act/repo/procdef/getTaskInfo',
    data: {id}
  })
}

// 根据实例id获取节点信息
export function getProInfo(id) {
  return request({
    url: serviceUrl.activitiService + '/act/hi/actinst/getProInfo',
    params: {id}
  })
}
